import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import {
  IClientNoteModel,
  ClientNoteModel,
} from '@common/models/ClientNoteModel';

export class ClientNoteService {
  private static baseUrl: string = '/api/clientNote';

  public static tags = {
    upsertClientNote: 'upsertClientNote',
  };

  static upsertClientNote = (
    request: IClientNoteModel,
  ): Promise<ClientNoteModel> =>
    trackPromise(
      new Promise<ClientNoteModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IClientNoteModel>(request)
          .then((json) => resolve(new ClientNoteModel(json)))
          .catch(reject);
      }),
      this.tags.upsertClientNote,
    );
}
